import { FormattedMessage } from 'react-intl';

import { CopyIcon } from '@dynatrace/strato-icons';

import { COPY_TO_CLIPBOARD_MESSAGES } from '../../copy-to-clipboard/copy-to-clipboard-messages.js';
import { ChartSeriesAction } from '../ChartSeriesAction.js';
import { handleCopyToClipboard } from '../utils/handleCopyToClipboard.js';

export const getDefaultAction = (item: { name: string | string[] }) => {
  return (
    <ChartSeriesAction.Item
      key="default-action"
      data-dt-children-name="TooltipCopyName"
      onSelect={() => {
        void handleCopyToClipboard(item?.name);
      }}
    >
      <ChartSeriesAction.ItemIcon>
        <CopyIcon />
      </ChartSeriesAction.ItemIcon>
      <FormattedMessage {...COPY_TO_CLIPBOARD_MESSAGES.copyActionName} />
    </ChartSeriesAction.Item>
  );
};
